'use client'

import useFetch from '@hook/useFetch'
import useLogin from '@hook/useLogin'
import { isWechat } from '@lib/utils'
import { assign, first, pick, split } from 'lodash-es'
import Script from 'next/script'
import { useEffect, useMemo, useState } from 'react'

export default function WechatShare({
  title = '',
  desc = '',
  imgUrl = ''
}) {
  const url = first(split(typeof window === 'undefined' ? '' : window.location.href, '#'))
  // 这里不用encodeURIComponent，因为接口自动会encode
  const { data } = useFetch(isWechat() ? 'jssdk/sign' : null, { url })
  const state = useMemo(() => ({ title, desc, link: url, imgUrl }), [title, desc, url, imgUrl])
  const [isReady, setIsReady] = useState(false)

  const { user } = useLogin()

  useEffect(() => {
    console.log('isReady', isReady)
    if (!isReady) return undefined

    if (
      !data
      || !data.appId
      || !data.timestamp
      || !data.nonceStr
      || !data.signature
    ) return undefined

    const { wx } = window
    if (!wx) return undefined

    const shareData = assign(
      {},
      state,
      {
        imgUrl: state.imgUrl || 'https://s.hougarden.com/build/static/img/page/common/logo-bg-blue.png'
      }
    )

    const config = assign(
      { debug: Boolean(user?.id === 21194) },
      pick(data, ['appId', 'timestamp', 'nonceStr', 'signature']),
      {
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
        ],
        openTagList: ['wx-open-launch-weapp']
      }
    )
    // 放入宏任务，等待页面需要微信相关的节点先渲染好
    setTimeout(() => {
      wx.config(config)
    }, 0)
    wx.ready(() => {
      wx.onMenuShareTimeline(shareData)
      wx.onMenuShareAppMessage(shareData)

      console.log('wx ready')
    })
    wx.error((err) => {
      console.log('wx.error', JSON.stringify(err))
    })

    return () => {
      wx.config({})
    }
  }, [isReady, data, state, url, user])

  if (!data) return null

  return (
    <Script
      src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"
      onReady={() => setIsReady(true)}
    />
  )
}
